import { defineStore } from 'pinia'
import { ref } from 'vue'

// 从localStorage获取已保存的视图，并过滤掉登录页面
const getStoredViews = () => {
  try {
    const stored = localStorage.getItem('visitedViews')
    const views = stored ? JSON.parse(stored) : []
    // 过滤掉登录页面
    return views.filter(view => view.path !== '/login')
  } catch (error) {
    console.error('Parse stored views error:', error)
    return []
  }
}

export const useTaskStore = defineStore('task', () => {
  // 访问过的视图，初始化时从localStorage获取
  const visitedViews = ref(getStoredViews())
  
  // 添加视图
  const addView = (view) => {
    // 如果是登录页面或设置了hideInTaskbar，则不添加到任务栏
    if (view.path === '/login' || view.meta?.hideInTaskbar) return
    
    // 如果已经存在，则不重复添加
    if (visitedViews.value.some(v => v.path === view.path)) return
    
    visitedViews.value.push({
      name: view.name,
      path: view.path,
      title: view.meta?.title || '未命名',
      icon: view.meta?.icon
    })
    // 保存到localStorage
    saveToStorage()
  }
  
  // 删除视图
  const delView = (path) => {
    const index = visitedViews.value.findIndex(v => v.path === path)
    if (index > -1) {
      visitedViews.value.splice(index, 1)
      // 保存到localStorage
      saveToStorage()
    }
  }
  
  // 清空视图
  const clearViews = () => {
    visitedViews.value = []
    // 清除localStorage
    localStorage.removeItem('visitedViews')
  }

  // 保存到localStorage的辅助函数
  const saveToStorage = () => {
    try {
      localStorage.setItem('visitedViews', JSON.stringify(visitedViews.value))
    } catch (error) {
      console.error('Save views to storage error:', error)
    }
  }

  return {
    visitedViews,
    addView,
    delView,
    clearViews
  }
}) 